const ITEMS = [
  "Transporte",
  "Umzüge",
  "Möbeltransporte",
  "Paletten",
  "Beiladungen",
  "Sperrgut",
  "Gewerbe",
  "Europaweit",
];

export const Marquee = () => (
  <div
    data-testid="marquee-band"
    className="relative w-full bg-[#f95700] border-y border-black/20 py-4 sm:py-5 overflow-hidden select-none"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0">
          {ITEMS.map((t) => (
            <span key={dup + t} className="flex items-center shrink-0">
              <span className="font-display uppercase font-black text-[9vw] sm:text-[3.6vw] leading-none text-white/95 px-5 sm:px-6">
                {t}
              </span>
              <span className="w-2 h-2 sm:w-2.5 sm:h-2.5 bg-black rotate-45 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
